import { enums } from "../shim/jsbridge";

const {
  NONE,
  CLOUD,
  CLOUD_FROM_PARENT,
  CLOUD_FROM_CHILD,
  TC,
  TC_FROM_PARENT,
  TC_FROM_CHILD,
  USER,
  USER_FROM_PARENT,
  USER_FROM_CHILD
} = enums.classification_sources;

const NONE_LABEL = "None";
const CLOUD_LABEL = "Spectra Intelligence";
const TC_LABEL = "Spectra Core";
const USER_LABEL = "User";
const FROM_PARENT_LABEL = "from parent";
const FROM_CHILD_LABEL = "from child";

const labels = {
  [NONE]: NONE_LABEL,
  [CLOUD]: CLOUD_LABEL,
  [CLOUD_FROM_PARENT]: `${CLOUD_LABEL} ${FROM_PARENT_LABEL}`,
  [CLOUD_FROM_CHILD]: `${CLOUD_LABEL} ${FROM_CHILD_LABEL}`,
  [TC]: TC_LABEL,
  [TC_FROM_PARENT]: `${TC_LABEL} ${FROM_PARENT_LABEL}`,
  [TC_FROM_CHILD]: `${TC_LABEL} ${FROM_CHILD_LABEL}`,
  [USER]: USER_LABEL,
  [USER_FROM_PARENT]: `${USER_LABEL} ${FROM_PARENT_LABEL}`,
  [USER_FROM_CHILD]: `${USER_LABEL} ${FROM_CHILD_LABEL}`
};

const extractedFileClassificationSources = [
  CLOUD_FROM_CHILD,
  TC_FROM_CHILD,
  USER_FROM_CHILD
];

const goodwareOverrideClassificationSources = [
  CLOUD_FROM_PARENT,
  TC_FROM_PARENT,
  USER_FROM_PARENT
];

export const CLASSIFICATION_LABELS_AND_ICONS: Record<
  number,
  { label: string; icon: string }
> = {
  [NONE]: {
    label: "",
    icon: ""
  },
  [CLOUD]: {
    label: "Threat Intelligence",
    icon: "cloud-intelligence"
  },
  [TC]: {
    label: "Static Analysis",
    icon: "static-analysis"
  },
  [USER]: {
    label: "Local Override",
    icon: "local"
  }
};

export const isClassificationReasonExtractedFile = (source: number) =>
  extractedFileClassificationSources.includes(source);

export const isClassificationReasonGoodwareOverride = (source: number) =>
  goodwareOverrideClassificationSources.includes(source);

export const isClassificationReasonUserOverride = (
  reason: string,
  source: number
) =>
  reason.toLowerCase() === "user classification" &&
  !isClassificationReasonExtractedFile(source) &&
  !isClassificationReasonGoodwareOverride(source);

export const isClassificationSourceTiCore = (source: number) => source === TC;

export const isClassificationSourceCloud = (source: number) => source === CLOUD;

export const isClassificationSourceLocalUser = (source: number) =>
  source === USER;

export const ClassificationSource = ({ value }: { value: number }) => (
  <>{labels[value]}</>
);

export const ClassificationSourceLabelWithIcon = ({
  source
}: {
  source: number;
}) => (
  <>
    <span
      className={`icon-${CLASSIFICATION_LABELS_AND_ICONS[source].icon} classification-source-icon`}
    ></span>
    <span>{CLASSIFICATION_LABELS_AND_ICONS[source].label}</span>
  </>
);

export default ClassificationSource;
